import { observer } from "mobx-react";
import React from "react";

type Props = {
  name: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  options?: any[];
  placeholder?: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  register?: (...args: any[]) => any;
};

function SelectInput({ name, options, placeholder, register }: Props) {
  return (
    <div className="form-input">
      <select
        // @ts-expect-error TS(2722) FIXME: Cannot invoke an object which is possibly 'undefin... Remove this comment to see the full error message
        {...register(name, { required: `${name} is required` })}
        placeholder={placeholder}
        name={name}
        autoComplete="off"
      >
        <option value="" disabled selected>
          Select your option
        </option>
        {/* @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'. */}
        {options.map((option) => (
          <option key={option.display_name} value={option.display_name}>
            {" "}
            {option.display_name}
          </option>
        ))}
      </select>
    </div>
  );
}

export default observer(SelectInput);
